import React from 'react';
import { Box, Card, StyledRawHtml, Typography } from '@applyboard/ui-components';
import { mobileBottomBorder } from "../../consts";
export var AdminComments = function AdminComments(_ref) {
  var comments = _ref.comments;
  return comments ? /*#__PURE__*/React.createElement(Box, {
    mb: 5,
    borderBottom: mobileBottomBorder
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: 'bold'
    }
  }, "Admin Comments"), /*#__PURE__*/React.createElement(StyledRawHtml, {
    html: comments
  }))) : null;
};